module.exports = __webpack_public_path__ + "static/media/uralcoin.7db10c85.svg";